import { IState } from '../../store';

export function isAgentSelector(state: IState): boolean {
  return !!state.userData?.isAuthenticated && !!state.userData.isAgent;
}
